// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"481":"11f85d2a","615":"ee661489"}[chunkId] + ".chunk.js";
};